import CheckIcon from "../../assets/icons/checkIcon";
import RefreshIcon from "../../assets/icons/refreshIcon";
import RocketIcon from "../../assets/icons/rocketIcon";
import PopUp from "../../components/popUp";
import { formatDate } from "../../utils/dateUtils";

import BoltIcon from "../../assets/icons/boltIcon";
import { ConfirmedMessageResponseDTO, PieceResponseDTOSimple } from "../../openapi-generated-client";
import "./pieceConfirmedHistoryPopUp.css";

interface PieceConfirmedHistoryPopUpProps {
    pieceData: PieceResponseDTOSimple;
    confirmedHistory: ConfirmedMessageResponseDTO[];
}

export default function PieceConfirmedHistoryPopUpProps(props: PieceConfirmedHistoryPopUpProps) {

    return <PopUp title={"History " + props.pieceData.title} className="big">
        <div className="piece-confirmed-history">
            <PieceConfirmedHistoryElement
                message={`Piece "${props.pieceData.title}" was created.`}
                type="created"
                date={new Date(props.pieceData.uploadDate)}
                user={props.pieceData.author}
            />
            {props.confirmedHistory.map((message, index) => {
                const output = [];
                output.push(<PieceConfirmedHistoryElement
                    key={index}
                    message={message.message ? message.message : ""}
                    type={message.confirmed ? "accept" : "reject"}
                    date={message.date ? new Date(message.date) : new Date()}
                    user={message.confirmedBy ? message.confirmedBy : ""}
                />);
                if(message.edited) {
                    output.push(<PieceConfirmedHistoryElement
                        key={index + "-edit"}
                        message={`Piece was edited`}
                        type="edit"
                        date={new Date(message.editedDate || message.date || new Date())}
                        user={props.pieceData.author} // Assuming the author is the one who edited
                    />
                    )
                }
                return output;
            })}
        </div>
    </PopUp>
}


interface PieceConfirmedHistoryElementProps {
    message: string;
    type: "accept" | "reject" | "edit" | "created";
    date: Date;
    user: string;
}


function PieceConfirmedHistoryElement(props: PieceConfirmedHistoryElementProps) {
    return (
        <div className={`piece-confirmed-history-element ${props.type}`}>
            <div className={"confirm-state icon" + (props.type === "edit" ? " yellow" : props.type === "reject" ? " brown" : props.type == "accept" ? " green" : "")}>
                {props.type === "accept" && <CheckIcon/>}
                {props.type === "reject" && <BoltIcon/>}
                {props.type === "edit" && <RefreshIcon/>}
                {props.type === "created" && <RocketIcon/>}
            </div>
            <p className="message-date">{formatDate(new Date(props.date))}</p>
            <p className="message-confirmed-by">{props.user}</p>
            <p className="message-text">{props.message}</p>
        </div>
    );

}